import { Button, Select, Table, notification } from "antd";
import MainLayout from "../../common/components/MainLayout";
import { UploadOutlined } from '@ant-design/icons';
import { useState } from "react";
import useCorreoAPI from "../hooks/useCorreoAPI";
import options from "./options";

export default () => {
    const [loading, setLoading] = useState(false)
    const api = useCorreoAPI()
    const [idsNotFound, setIdsNotFound] = useState<number[]>([])
    const [ estado, setEstado ] = useState<number>(1);

    const uploadRendiciones = () => {
        const input = document.createElement("input")
        input.type = 'file'
        input.multiple = true
        input.click()
        input.oninput = async (evt) => {
            if (input.files && input.files.length > 0) {
                setLoading(true)
                let error = false
                try {                    
                    const response = await api.cargarRendiciones(input.files, estado);
                        if (response.data) {
                            setIdsNotFound(response.data!)
                        }                    
                    error = response.error;
                }
                catch (e) {
                    console.error(e)
                    error = true
                }
                if (error) {
                    notification.error({ message: "Error al cargar las rendiciones" })
                    setLoading(false);
                }
                else {
                    notification.success({ message: "Rendiciones cargadas correctamente" })
                    setLoading(false);
                }

                setLoading(false)
            }
            input.remove()
        }
    }    
    return (<MainLayout title="Cargar rendiciones de correo">
        <Select
        optionFilterProp="children"                    
        allowClear
        size = "middle"
        style = {{ width: "25%", padding: "0 25px 0 0" }}
        onChange = {(e) => setEstado(e)}
        defaultValue = { estado }        
        >
            {
                options.map(e =>
                    <Select.Option key={ e.Id } value= { e.Value }>{ e.Nombre }</Select.Option>
                )
            }
        </Select><br/>
        <Button loading={loading} onClick={uploadRendiciones} style={{ marginTop: 20 }} icon={<UploadOutlined />}>Subir archivos</Button>
        {<Table loading={loading} style={{ marginTop: 20 }} dataSource={idsNotFound.map(id => ({ id }))} columns={[
            {
                title: "Infracciones no encontradas",
                dataIndex: "id",
                key: 'id'
            }
        ]} />}
    </MainLayout>)
}